import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import EmptyDataIcon from '@/components/common/EmptyDataIcon'

const StyledGridOverlay = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
}))

interface props {
  text: string
  height?: number | string
  colorText?: string
}

const NoData = ({ text, height = 400, colorText }: props) => {
  return (
    <div style={{ height: height, width: '100%' }}>
      <StyledGridOverlay>
        <EmptyDataIcon />
        <Box sx={{ mt: 1 }}>
          <Typography color={colorText ? colorText : 'text.main'}>
            {text}
          </Typography>
        </Box>
      </StyledGridOverlay>
    </div>
  )
}

export default NoData
